<template>
  <vx-card heading-size="h1" title="Make a Suggestion">
    <p class="mb-10">
      We are always trying to improve Virtual Job Experience for students (and teachers) so if you
      feel there is something that needs to be added or if there is a better way to do something,
      please complete the form and let us know.<br /><br />

      We will provide you with feedback on your idea/suggestion within 2 school days.
    </p>

    <vs-input
      autocomplete="given-name"
      class="w-full"
      label-placeholder="First Name"
      v-model="name"
      v-validate="'required'"
      name="name"
    ></vs-input>
    <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

    <vs-input
      autocomplete="email"
      class="w-full mt-8"
      label-placeholder="Email"
      v-model="email"
      v-validate="'required|email'"
      name="email"
    ></vs-input>
    <span class="text-danger text-sm" v-show="errors.has('email')">{{
      errors.first('email')
    }}</span>

    <vs-input
      class="w-full mt-8"
      label-placeholder="School"
      v-model="school"
      v-validate="'required'"
      name="school"
    ></vs-input>
    <span class="text-danger text-sm" v-show="errors.has('school')">{{
      errors.first('school')
    }}</span>

    <vs-textarea
      rows="6"
      class="w-full mt-8"
      placeholder="Idea/Suggestion"
      v-model="idea"
      v-validate="'required'"
      name="idea"
    ></vs-textarea>
    <span class="text-danger text-sm" v-show="errors.has('idea')">{{ errors.first('idea') }}</span>

    <div class="flex flex-wrap items-center justify-end">
      <form @submit.prevent="validateForm">
        <button class="btn btn-primary btn-size-medium ml-auto mt-2" button="submit">
          Submit Suggestion
        </button>
      </form>
    </div>
    <vs-progress indeterminate color="primary" v-if="sending"></vs-progress>
  </vx-card>
</template>

<script>
import { Validator } from 'vee-validate';
import theApi from '@/mixins/theApi';
import store from '@/store/store';
const dict = {
  custom: {
    surname: {
      required: 'The last name field is required',
    },
    confirm_password: {
      confirmed: "The password confirmation doesn't match",
    },
  },
};

// register custom messages
Validator.localize('en', dict);

export default {
  computed: {
    teacherAccessType() {
      return store.getters['authTeacher/accessType'];
    },
  },
  data() {
    return {
      name: '',
      email: '',
      school: '',
      idea: '',
      sending: false,
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitForm();
        }
      });
    },
    async submitForm() {
      const formData = new FormData();
      formData.append('name', this.name);
      formData.append('email', this.email);
      formData.append('school', this.school);
      formData.append('idea', this.idea);

      this.sending = true;
      theApi.methods
        .makeCall(
          false,
          'suggestion/submit',
          'post',
          formData,
          'Suggestion submitted successfully.',
          true,
        )
        .then(
          () => {
            this.sending = false;
            this.name = '';
            this.email = '';
            this.school = '';
            this.idea = '';

            this.$nextTick(() => {
              this.errors.clear();
              this.$nextTick(() => {
                this.$validator.reset();
              });
            });
          },
          () => {
            this.sending = false;
          },
        );
    },
  },
  mounted() {
    this.name = store.getters['authTeacher/fName'] + ' ' + store.getters['authTeacher/lName'];
    this.email = store.getters['authTeacher/email'];
    this.school = store.getters['authTeacher/school'];
  },
};
</script>
